// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"O4-z","colorTextValue":"P4-z","swatches":"Q4-z","collapseLink":"R4-z","isCollapsed":"S4-z","dropdown":"T4-z","disabled":"U4-z"};